import { wrapWithQoutes } from "../helperFuncs"


export const GenerateCsvDownload = async(data) => {
    const rateSheet = data.fsc_rate_sheet
    const rates = data.fsc_rates

    const fileName = `${rateSheet.fsc_name} - FSC`
    
    const rows = []

    try {
        let lo = 1
        let hi = 10
        let dieselBands = ["",""]
        if (rateSheet.method_id === 40) {
            rates.forEach(r => {
                let diesel = `$${r.diesel_low.toFixed(3)} - $${r.diesel_high.toFixed(3)}`
                rows.push([diesel, r.rate.toFixed(3)])
            })
        } else {
            let rateBands = {[lo]: [hi]}
            rates.forEach((r) => {
                if (r.mileage_low === 1) {
                    dieselBands.push(`$${r.diesel_low.toFixed(2)} - $${r.diesel_high.toFixed(2)}`)
                }
                if (r.mileage_low in rateBands) {
                    rateBands[r.mileage_low].push(r.rate)
                } else {
                    rateBands[r.mileage_low] = [r.mileage_high, r.rate]
                }
            })
            rows.push(dieselBands)
            for (const [k, v] of Object.entries(rateBands)) {
                let newRow = [k, v[0]]
                v.forEach((r, i) => {
                    if (i > 0) {
                        newRow.push(r.toFixed(3))
                    }
                })
                rows.push(newRow)
            }
        }
        const content = rows.map(row => row.map(wrapWithQoutes).join(",")).join("\r\n")
        const blob = new Blob([content], {type : "text/csv;charset=utf-8"})
        const url = URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href =url
        link.setAttribute("download", `${fileName}.csv`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
    } catch (err) {
        console.error(err)
    }
}